/* Add to Cart guard.

   The theme updates the form's variant id, then refetches the whole section
   over the network to redraw the buy panel. Between those two steps the form
   can still be holding the previous variant, and an audit caught a click
   landing inside that window: the page showed a framed canvas, the cart
   received an unframed print. The window measured 56ms on a warm desktop
   connection; on mobile data it is long enough for an ordinary tap.

   `variant-radios` resolves the correct variant well before the network work
   finishes, so at the moment of submit this reads the truth and corrects the
   form. If the picker has not settled yet (changing finish can pass through a
   combination that does not exist before it lands on one that does), the
   submit is held rather than sent with a stale id, and replayed as soon as the
   picker lands. The customer's tap still adds the thing they are looking at. */
(function () {
  'use strict';
  if (window.__kvpAtcGuard) return;
  window.__kvpAtcGuard = true;

  var WAIT_MS = 2500;      /* give up rather than hang if it never settles */
  var POLL_MS = 60;

  function picker() {
    return document.querySelector('variant-selects, variant-radios');
  }

  function guard(form) {
    if (form.__kvpGuarded) return;
    form.__kvpGuarded = true;

    form.addEventListener(
      'submit',
      function (e) {
        if (form.__kvpReplaying) return;          /* our own replayed submit */

        var p = picker();
        var input = form.querySelector('input[name="id"]');
        if (!p || !input) return;

        var current = p.currentVariant;

        if (current && current.id) {
          if (String(input.value) !== String(current.id)) input.value = current.id;
          return;                                  /* correct, let it through */
        }

        /* Not settled. Hold the submit and replay it when it lands. */
        e.preventDefault();
        e.stopImmediatePropagation();

        var submitter = e.submitter || form.querySelector('[name="add"]');
        var waited = 0;

        (function wait() {
          var now = picker() && picker().currentVariant;
          if (now && now.id) {
            var fresh = document.querySelector('form[action*="/cart/add"]') || form;
            var freshInput = fresh.querySelector('input[name="id"]');
            if (freshInput) freshInput.value = now.id;
            fresh.__kvpReplaying = true;
            var btn = fresh.querySelector('[name="add"]') || submitter;
            if (btn && btn.disabled) btn.disabled = false;
            if (fresh.requestSubmit) fresh.requestSubmit(btn);
            else fresh.submit();
            setTimeout(function () { fresh.__kvpReplaying = false; }, 0);
            return;
          }
          waited += POLL_MS;
          if (waited < WAIT_MS) setTimeout(wait, POLL_MS);
        })();
      },
      true /* capture, so this runs before the theme's own submit handler */
    );
  }

  /* ---------------------------------------------------------------------
     The update window.

     While the theme refetches the section it disables the button and labels it
     "Unavailable", a stock message rather than a loading state, and because the
     button is disabled the browser never fires a submit, so the hold-and-replay
     above never runs and the tap is swallowed. Tapping a finish and then
     tapping Add to Cart is the most common thing anyone does on this page, so
     the window has to stay open however long it lasts.

     So for the duration of the window the button is kept clickable and labelled
     as what it actually is: updating. The stale price is hidden rather than
     shown against the wrong variant. When the picker settles the theme's own
     state takes over again, including a genuine "Unavailable" if that is what
     the customer has landed on. */

  var LOADING = 'Updating';
  var updating = false;
  var settleTimer = null;
  var lastBtn = null;
  var enforcer = null;

  function currentBtn() {
    return document.querySelector('form[action*="/cart/add"] [name="add"]');
  }

  function labelNode(btn) {
    var host = btn.querySelector('.button_flex_new') || btn;
    for (var i = 0; i < host.childNodes.length; i++) {
      var n = host.childNodes[i];
      if (n.nodeType === 3 && n.nodeValue.trim()) return n;
    }
    return null;
  }

  /* Idempotent, and re-applied on every mutation: the theme rewrites this
     button repeatedly during the window, so a one-shot would be overwritten. */
  function enforce() {
    if (!updating) return;
    var btn = currentBtn();
    if (!btn) return;

    if (btn !== lastBtn || priceCaughtUp(btn)) { settle(); return; }   /* refetch landed */

    if (btn.disabled) btn.disabled = false;

    var node = labelNode(btn);
    if (node && node.nodeValue.trim() !== LOADING) {
      if (!btn.dataset.kvpLabel && !/unavailable/i.test(node.nodeValue)) {
        btn.dataset.kvpLabel = node.nodeValue;
      }
      node.nodeValue = LOADING;
    }
    var price = btn.querySelector('.mian-product_price');
    if (price && price.style.visibility !== 'hidden') price.style.visibility = 'hidden';
  }

  /* The window is over when the price written into the button matches the
     variant the picker has resolved: that price comes from markup the theme
     only swaps in once the refetch has landed, so it is the true completion
     signal rather than a guess at timing. */
  function priceCaughtUp(btn) {
    var p = picker();
    if (!p || !p.currentVariant) return false;
    var span = btn.querySelector('.compare-product_price');
    if (!span) return false;
    var shown = parseFloat((span.textContent || '').replace(/[^0-9.]/g, ''));
    if (!isFinite(shown)) return false;
    return Math.abs(shown - p.currentVariant.price / 100) < 0.01;
  }

  function settle() {
    updating = false;
    clearTimeout(settleTimer);
    if (enforcer) { enforcer.disconnect(); enforcer = null; }
    var btn = currentBtn();
    if (!btn) return;
    var p = picker();
    var resolved = p && p.currentVariant && p.currentVariant.id;
    var node = labelNode(btn);
    if (node && node.nodeValue.trim() === LOADING) {
      node.nodeValue = resolved ? (btn.dataset.kvpLabel || 'Add to cart ') : 'Unavailable';
    }
    var price = btn.querySelector('.mian-product_price');
    if (price) price.style.visibility = '';
    btn.disabled = !resolved;
    delete btn.dataset.kvpLabel;
  }

  function hold() {
    var btn = currentBtn();
    if (!btn) return;
    updating = true;
    lastBtn = btn;
    clearTimeout(settleTimer);
    settleTimer = setTimeout(settle, 5000);      /* never leave it stuck */
    if (enforcer) enforcer.disconnect();
    enforcer = new MutationObserver(enforce);
    enforcer.observe(btn, { attributes: true, childList: true, subtree: true, characterData: true });
    enforce();
  }

  /* Any interaction with the picker starts a window. Bubble phase plus a tick,
     so the theme has already applied its own disabled state and "Unavailable"
     label by the time this runs and there is nothing left to overwrite it. */
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('variant-selects, variant-radios, .mixed-variant-picker')) return;
    setTimeout(hold, 0);
  });

  /* Start the window on the tap itself, synchronously, before the theme's
     change handler runs, so the loading state is claimed first and the stock
     "Unavailable" label never gets to be the current state. How long the
     theme's own work actually takes is unmeasured: the figures we had came
     from a hidden tab, where Chrome clamps timers to about 1Hz, so they
     measured the clamp rather than the page. Claiming the label early is
     cheap and correct either way. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('variant-selects, variant-radios, .mixed-variant-picker')) return;
    hold();
  }, true);

  setInterval(enforce, 80);   /* backstop if a mutation is missed */

  function scan() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(guard);
  }

  function boot(n) {
    scan();
    if (!document.querySelector('form[action*="/cart/add"]') && n < 25) {
      setTimeout(function () { boot(n + 1); }, 200);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(0); });
  else boot(0);

  /* A variant change can replace the form element itself. */
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
